export type TurnCycleStatus = 'IDLE' | 'ROLLING' | 'CHOOSING' | 'FINALIZING';

const VALID_TRANSITIONS: Record<TurnCycleStatus, TurnCycleStatus[]> = {
  IDLE: ['CHOOSING'],
  ROLLING: ['CHOOSING', 'FINALIZING'],
  CHOOSING: ['ROLLING', 'FINALIZING', 'IDLE'],
  FINALIZING: ['CHOOSING', 'IDLE'],
};

export function canTransition(from: TurnCycleStatus, to: TurnCycleStatus): boolean {
  return VALID_TRANSITIONS[from]?.includes(to) ?? false;
}

export function transitionTo(current: TurnCycleStatus, next: TurnCycleStatus): TurnCycleStatus {
  if (!canTransition(current, next)) {
    throw new Error(`Invalid turn cycle transition: ${current} -> ${next}`);
  }
  return next;
}

export function computeStatusAfterRoll(didBust: boolean, allKept: boolean): TurnCycleStatus {
  if (didBust) return 'FINALIZING';
  return allKept ? 'FINALIZING' : 'CHOOSING';
}

export function computeStatusAfterKeep(
  currentStatus: TurnCycleStatus,
  allKept: boolean,
): TurnCycleStatus {
  if (allKept) return 'FINALIZING';
  return currentStatus === 'FINALIZING' ? 'CHOOSING' : currentStatus;
}
